export default {
    brand(state) {
        return state.brand;
    },
    brandById(state) {
        return state.brandById;
    },
    brandForSelect(state) {
        const brands = [];

        for (const index in state.brand) {
            const brandItem = {
                id: state.brand[index].id,
                text: state.brand[index].name
            }

            brands.push(brandItem);
        }

        return brands;
    },
    product(state) {
        return state.product;
    },
    productById(state) {
        return state.productById;
    },
}